const ViewportKind = {
	MOBILE: 'mobile',
	REGULAR: 'regular',
} as const;

export default ViewportKind;
